<template>
  <div>
    <div class="tableTop" :class="{'has-locate': showLocate}">
      <el-button type="primary" size="mini" @click="addFn">新增</el-button>
      <div class="locateBox" v-if="showLocate">
        <el-input class="locateInput" size="mini" v-model="locatePlateNumber" placeholder="输入车牌号定位" clearable
          @keyup.enter.native="locateFn" @clear="clearLocate"></el-input>
        <el-button type="primary" size="mini" plain @click="locateFn">定位</el-button>
      </div>
    </div>
    <el-table :data="goodform.billCarriers"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border>
      <el-table-column type="index"  label="序号" width="60"></el-table-column>
      <el-table-column label="操作"  width="100">
        <template slot-scope="scope">
          <div>
            <el-button type="text" size="mini" @click="delFn(scope.$index)">删除</el-button>
            <el-button type="text" v-if="scope.row.WHJKflag==1" size="mini" @click="sijiFn(scope.$index)">司机</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="承运商" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>承运商</div>
        </template>
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.id">{{scope.row.generalCarrier?scope.row.generalCarrier:'-'}}</span>
            <el-form-item label="" :prop="'billCarriers.' +scope.$index+ '.generalCarrier'" :key="scope.$index" v-else   class="table_error" :rules="rules.generalCarrier"  >
              <el-select  v-model="goodform.billCarriers[scope.$index].generalCarrier" filterable placeholder="请选择" clearable   @change="generalCarrierChange($event,scope.row)">
                <el-option v-for="item in CYSList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="推送网货" min-width="100">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.id">{{scope.row.onlineFreightFlag||scope.row.onlineFreightFlag=='0'?['否','是'][scope.row.onlineFreightFlag]:'-'}}</span>
            <el-form-item label=""  :key="scope.$index" v-else   class="table_error" >
              <div v-if="scope.row.onlineFlag==1">
                <el-select  v-model="goodform.billCarriers[scope.$index].onlineFreightFlag" @change="TSWHchange($event,scope.row)"  placeholder="请选择" clearable    >
                  <el-option label="是" :value="1" ></el-option>
                  <el-option label="否" :value="0" ></el-option>
                </el-select>
              </div>
              <span v-else>-</span>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="服务费计算" min-width="100">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.id">{{scope.row.reverseCountFlag||scope.row.reverseCountFlag=='0'?['正算','反算'][scope.row.onlineFreightFlag]:'-'}}</span>
            <el-form-item label=""  :key="scope.$index" v-else   class="table_error" >
              <div v-if="scope.row.generalCarrier">
                  <el-select  v-model="goodform.billCarriers[scope.$index].reverseCountFlag"  placeholder="请选择" clearable    >
                  <el-option label="反算" value="1" ></el-option>
                  <el-option label="正算" value="0" ></el-option>
                </el-select>
              </div>
              <span v-else>-</span>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="车牌号" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>车牌号</div>
        </template>
        <template slot-scope="scope">
          <div>
            <el-form-item label="" v-if="scope.row.WHJKflag==1||scope.row.id"   class="table_error" >
              {{scope.row.plateNumber}}
            </el-form-item>
            <div style="display:flex;align-items: center;" v-else>
              <el-form-item label="" :prop="'billCarriers.' +scope.$index+ '.plateNumber'" :key="scope.$index" :rules="rules.plateNumber" class="table_error" >
                <el-autocomplete class="inline-input" v-model.trim="goodform.billCarriers[scope.$index].plateNumber" :popper-append-to-body="false" @blur="carBlurFn(scope.$index)"
                :fetch-suggestions="(queryString, cb) => { searchFn1(queryString, cb, scope.row)}" value-key="id" @select="dbSelected1($event,scope.$index)"  popper-class="xiala">
                      <template slot-scope="{ item }">
                          <div style="position: relative;">
                          <div class="name">{{ item.vhcNo }} / {{ [ "外协", "自有" ][item.vhcClassify-1]}}</div>
                        </div>
                    </template>
                </el-autocomplete>
              </el-form-item>
              <i  class="el-icon-circle-plus-outline el-input__icon"  slot="suffix"  @click="addVL(scope.$index)">  </i>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="司机" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>司机</div>
        </template>
        <template  slot-scope="scope">
          <div>
            <el-form-item label="" v-if="scope.row.WHJKflag==1||scope.row.id"  class="table_error" >
              {{scope.row.driverName}}
            </el-form-item>
            <div style="display:flex;align-items: center;" v-else>
              <el-form-item label=""  :prop="'billCarriers.' +scope.$index+ '.driverName'" :key="scope.$index" :rules="rules.driverName"  class="table_error" >
              <el-autocomplete class="inline-input" v-model.trim="goodform.billCarriers[scope.$index].driverName" :popper-append-to-body="false"  @blur="sijiBlurFn(scope.$index)"
                  :fetch-suggestions="(queryString, cb) => { searchFn2(queryString, cb, scope.row)}" value-key="id" @select="dbSelected2($event,scope.$index)" popper-class="xiala">
                    <template slot-scope="{ item }">
                        <div style="position: relative;">
                        <div class="name">{{ item.name }} / {{ [ "外协", "自有" ][item.driverClassify-1]}}{{item.mobile}}</div>
                      </div>
                  </template>
              </el-autocomplete>
              </el-form-item>
              <i  class="el-icon-circle-plus-outline el-input__icon"  slot="suffix"  @click="addsiji(scope.$index)">  </i>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>联系电话</div>
        </template>
        <template slot-scope="scope">
          <div>
            <el-form-item label=""  class="table_error"  >
              {{scope.row.driverPhone}}
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="身份证号" min-width="120">
        <template slot-scope="scope">
          <div >
            <el-form-item label=""  class="table_error"  >
              {{scope.row.idNumber}}
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收款方类型" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>收款方类型</div>
        </template>
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.id">{{['企业','司机','车队长'][scope.row.collectionType-1]}}</div>
            <div v-else>
               <el-form-item label="" prop="payCustomerName" v-if="scope.row.generalCarrier">
                {{scope.row.collectionTypeName}}
              </el-form-item>
              <el-form-item label="" v-else :prop="'billCarriers.' +scope.$index+ '.collectionType'" :key="scope.$index" :rules="rules.collectionType"  class="table_error">
                <el-select  v-model="goodform.billCarriers[scope.$index].collectionType"  placeholder="请选择" clearable    @change="collectionTypeFn($event,scope.row)">
                  <el-option label="企业" :value="1" ></el-option>
                  <el-option label="司机" :value="2" ></el-option>
                  <el-option label="车队长" :value="3" ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收款方" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>收款方</div>
        </template>
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.id">{{scope.row.payer}}</div>
            <div v-else>
              <el-form-item label="" prop="payCustomerName" v-if="scope.row.generalCarrier">
                {{scope.row.generalCarrier}}
              </el-form-item>
              <el-form-item label="" :prop="'billCarriers.' +scope.$index+ '.payer'" :rules="[{ required: true, message: '请选择收款方', trigger: 'blur' }]" class="width1" v-else-if="scope.row.collectionType==1&&!scope.row.generalCarrier">
                <el-select  v-model="goodform.billCarriers[scope.$index].payer" filterable placeholder="请选择"  @change="payerChange($event,scope.row)">
                  <el-option v-for="item in CYSList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" label-width="120px"  v-else-if="scope.row.collectionType==2">
                {{scope.row.driverName}}
              </el-form-item>
              <div v-else-if="scope.row.collectionType==3">
                <el-form-item label=""  :prop="'billCarriers.' +scope.$index+ '.payer'"  :rules="rules.payer" label-width="120px"  >
                  <el-autocomplete class="inline-input" v-model.trim="goodform.billCarriers[scope.$index].payer"  placeholder="车队长姓名"
                      :fetch-suggestions="querySearch" value-key="payerTaxId" @select="handleSelect($event,scope.row)" popper-class="xiala">
                        <template slot-scope="{ item }">
                            <div style="position: relative;">
                            <div class="name">{{ item.payer }} / {{ item.payerTaxId? item.payerTaxId:''}}</div>
                          </div>
                      </template>
                  </el-autocomplete>
                </el-form-item>
                <el-form-item label="" :prop="'billCarriers.' +scope.$index+ '.payerTaxId'"  :rules="rules.payerTaxId" label-width="120px">
                  <el-input  placeholder="身份证号"    maxlength="50" v-model="goodform.billCarriers[scope.$index].payerTaxId"  ></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="支出方式" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>支出方式</div>
        </template>
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.id">{{scope.row.expenditurePatternName}}</div>
            <el-form-item label="" v-else :prop="'billCarriers.' +scope.$index+ '.expenditurePattern'" :key="scope.$index" :rules="rules.expenditurePattern"  class="table_error">
              <el-select  v-model="goodform.billCarriers[scope.$index].expenditurePattern"  placeholder="请选择"  @change="zcfsChange($event,scope.row)">
                <el-option v-for="item in ZHFSlist"  :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费计价" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>运费计价</div>
        </template>
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.id">{{scope.row.expenditurePatternName}}</div>
            <el-form-item label=""  v-else :prop="'billCarriers.' +scope.$index+ '.freightPricingType'" :key="scope.$index" :rules="rules.freightPricingType"  class="table_error">
              <el-select  v-model="goodform.billCarriers[scope.$index].freightPricingType"  placeholder="请选择" @change="jijiaChange($event,scope.row)">
                <template  v-for="item in SRJJlist">
                     <el-option  :label="item.showName" v-if="item.showName.includes(goodform.measuringUnit)||item.showName=='包干'" :value="item.itemNo" :key="item.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费单价" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>运费单价</div>
        </template>
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.id">{{scope.row.freightUnitPrice}}</div>
            <div  v-else>
              <el-form-item label="" v-if="scope.row.freightPricingType!=1" :prop="'billCarriers.' +scope.$index+ '.freightUnitPrice'" :key="scope.$index" :rules="rules.freightUnitPrice"  class="table_error">
                <el-input  placeholder=""  v-number-input.float="2" maxlength="8" v-model="goodform.billCarriers[scope.$index].freightUnitPrice"  ></el-input>
              </el-form-item>
              <span v-else>-</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费金额(元)" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>运费金额(元)
          </div>
        </template>
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.id">{{scope.row.freightAmount}}</div>
            <el-form-item label=""  v-else :prop="'billCarriers.' +scope.$index+ '.freightAmount'" :key="scope.$index" :rules="rules.freightAmount"  class="table_error">
              <el-input  placeholder=""  v-number-input.float="2" maxlength="8" v-model="goodform.billCarriers[scope.$index].freightAmount"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="服务费率%" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>服务费率%</div>
        </template>
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.id">{{scope.row.serviceRate}}</div>
            <el-form-item label=""  v-else :prop="'billCarriers.' +scope.$index+ '.serviceRate'" :key="scope.$index" :rules="rules.serviceRate"  class="table_error">
              <el-input  placeholder=""  v-number-input.float="2" maxlength="8" v-model="goodform.billCarriers[scope.$index].serviceRate"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费税率%" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>运费税率%</div>
        </template>
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.id">{{scope.row.freightTaxRate}}</div>
            <el-form-item label=""  v-else :prop="'billCarriers.' +scope.$index+ '.freightTaxRate'" :key="scope.$index" :rules="rules.freightTaxRate"  class="table_error">
              <el-input  placeholder=""  v-number-input.float="2" maxlength="8" v-model="goodform.billCarriers[scope.$index].freightTaxRate"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <addDriver v-if="addDriverFlag" :addDriverFlag.sync='addDriverFlag' @cDaddFn="dbSelected2($event,currentIndex)"></addDriver>
    <addVehicle v-if="addVehicleFlag" :addVehicleFlag.sync='addVehicleFlag' @cVIaddFn="dbSelected1($event,currentIndex)"></addVehicle>
    <WHxuansiji v-if="WHxuansijiFlag" :WHxuansijiFlag.sync='WHxuansijiFlag' @selectCar="selectCar"></WHxuansiji>
  </div>
</template>

<script>
import { getDictionaryDetailList, cDlist, cVIlist, findCustomerInfoList, getWayForPlateNumber, getCustomerTaxRate, pushWayToWHPTFlag,
  findVehicleLeaderList, findPriceVehicleList, findDriverInfoById } from '@/api/newTMS'
import { selectTMSTenantListByCustom } from '@/api/newCrm'
import addDriver from '@/views/newTMS/publicFiles/wayAndOrder/addDriver.vue'
import addVehicle from '@/views/newTMS/publicFiles/wayAndOrder/addVehicle.vue'
import WHxuansiji from '@/views/newTMS/publicFiles/wayAndOrder/WHxuansiji.vue'
import { toFixed } from '@/utils/util'
export default {
  name: 'shouru',
  components: {
    addDriver, addVehicle, WHxuansiji
  },
  props: {
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    },
    // 是否显示车牌号定位（仅从「修改」弹框引用时开启，其他页面引用不受影响）
    showLocate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      locatePlateNumber: '', // 车牌号定位关键字
      ZHFSlist: [],
      SRJJlist: [],
      CYSList: [],
      XZCLflag: false,
      searchFrom1: {
        pageNo: 1,
        pageSize: 1000
      },
      total2: 0,
      XZSJflag: false,
      searchFrom2: {
        pageNo: 1,
        pageSize: 1000
      },
      addDriverFlag: false,
      addVehicleFlag: false,
      WHxuansijiFlag: false,
      rules: {
        plateNumber: [
          { required: true, message: '请选择车辆', trigger: 'blur' }
        ],
        driverName: [
          { required: true, message: '请选择司机', trigger: 'blur' }
        ],
        payer: [
          { required: true, message: '车队长名称', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        allFreightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ],
        generalCarrier: [
          { required: true, message: '请选择承运商', trigger: 'blur' }
        ]
      },
      currentIndex: ''
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    // 默认为自有
    if (!this.goodform.driverOwnership && this.goodform.driverOwnership !== 0) {
      this.$set(this.goodform, 'driverOwnership', 0)
      this.$set(this.goodform, 'driverOwnershipName', '自有')
    }
    if (!this.goodform.vehicleOwnership && this.goodform.vehicleOwnership !== 0) {
      this.$set(this.goodform, 'vehicleOwnership', 0)
      this.$set(this.goodform, 'vehicleOwnershipName', '自有')
    }
    getDictionaryDetailList({ dictionaryType: 'down_settlement_type' }).then(res => { this.ZHFSlist = res })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => { this.SRJJlist = res })
    findCustomerInfoList({ businessType: 2 }).then(res => {
      selectTMSTenantListByCustom(res).then(res1 => { this.CYSList = res1 })
    })
  },
  methods: {
    // 获取自由车价格
    getziyouchePriceFn (row) {
      if (this.goodform.vehicleOwnership == 1) {
        return
      }
      if (this.goodform.productTypeName && this.goodform.startDirection && this.goodform.endDirection && row.energyTypeName && row.freightPricingTypeName) {
        findPriceVehicleList({
          productTypeName: this.goodform.productTypeName,
          startDirection: this.goodform.startDirection,
          endDirection: this.goodform.endDirection,
          energyTypeName: row.energyTypeName,
          freightPricingTypeName: row.freightPricingTypeName
        }).then(res => {
          if (res.price) {
            if (row.freightPricingType == 1) { // 包干
              this.$set(row, 'freightUnitPrice', '')
              this.$set(row, 'freightAmount', res.price)
            } else {
              this.$set(row, 'freightAmount', '')
              this.$set(row, 'freightUnitPrice', res.price)
            }
          } else {
            // this.$set(row, 'freightUnitPrice', '')
            // this.$set(row, 'freightAmount', '')
          }
        })
      }
    },
    addFn () {
      this.goodform.billCarriers.push({
        expenditurePattern: '1',
        expenditurePatternName: '现结',
        freightPricingType: '0',
        freightPricingTypeName: '按吨',
        serviceRate: 0,
        collectionType: 1,
        collectionTypeName: '企业',
        freightTaxRate: 9
      })
    },
    // 车牌号定位
    locateFn () {
      this.doLocate('table', this.goodform.billCarriers, ['plateNumber'], this.locatePlateNumber, '车牌号')
    },
    clearLocate () {
      this.clearLocateHighlight('table')
    },
    // 通用定位：tableRef 表格ref，list 表格数据，props 参与匹配的字段，keyword 关键字（支持逗号/空格分隔多个）
    doLocate (tableRef, list, props, keyword, label) {
      const table = this.$refs[tableRef]
      if (!table) return
      const keys = (keyword || '').split(/[,，\s]+/).filter(item => item)
      if (!keys.length) {
        this.$message({ message: '请输入' + label + '后再定位', type: 'warning' })
        return
      }
      const wrapper = table.$el.querySelector('.el-table__body-wrapper')
      const rows = wrapper ? wrapper.querySelectorAll('tbody > tr') : []
      const indexs = []
      list.forEach((item, index) => {
        const hit = props.some(prop => {
          const val = item[prop] === null || item[prop] === undefined ? '' : String(item[prop]).toUpperCase()
          return val && keys.some(key => val.indexOf(key.toUpperCase()) > -1)
        })
        if (hit) indexs.push(index)
      })
      // 先清掉上一次的高亮
      this.clearLocateHighlight(tableRef)
      if (!indexs.length) {
        this.$message({ message: '未找到该' + label, type: 'warning' })
        return
      }
      indexs.forEach(index => {
        if (rows[index]) rows[index].classList.add('locate-highlight')
      })
      // 滚动到第一个匹配行
      const firstRow = rows[indexs[0]]
      if (wrapper && firstRow) {
        const wrapperRect = wrapper.getBoundingClientRect()
        const rowRect = firstRow.getBoundingClientRect()
        const top = wrapper.scrollTop + (rowRect.top - wrapperRect.top) - wrapper.clientHeight / 2 + rowRect.height / 2
        wrapper.scrollTop = top > 0 ? top : 0
      }
      // 5 秒后自动取消高亮
      clearTimeout(this.locateTimer)
      this.locateTimer = setTimeout(() => {
        this.clearLocateHighlight(tableRef)
      }, 5000)
    },
    clearLocateHighlight (tableRef) {
      const table = this.$refs[tableRef]
      if (!table) return
      const rows = table.$el.querySelectorAll('.el-table__body-wrapper tbody > tr')
      rows.forEach(item => item.classList.remove('locate-highlight'))
    },
    delFn (index) {
      if (this.goodform.billCarriers.length == 1) {
        this.$alert('最后一条人车信息不能删除', '系统提示')
        return
      }
      if (this.goodform.billCarriers[index].id) {
        this.goodform.deleteCarrierRelIds.push(this.goodform.billCarriers[index].id)
      }
      this.goodform.billCarriers.splice(index, 1)
    },
    // 支出方式修改
    zcfsChange (e, row) {
      let json = this.ZHFSlist.filter(item => item.itemNo == e)
      row.expenditurePatternName = json[0].showName
    },
    // 运费计价修改
    jijiaChange (e, row) {
      let json = this.SRJJlist.filter(item => item.itemNo == e)
      row.freightPricingTypeName = json[0].showName
      if (row.freightPricingType == 1) {
        this.$set(row, 'freightUnitPrice', '')
        this.$set(row, 'allFreightAmount', '')
      } else {
        this.$set(row, 'freightUnitPrice', '')
        this.$set(row, 'allFreightAmount', '')
      }
      this.getziyouchePriceFn(row)
    },
    // 车队长查询
    querySearch (str, cb) {
      findVehicleLeaderList({ payer: str }).then(res => {
        cb(res)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    handleSelect (e, row) {
      this.$set(row, 'payer', e.payer)
      this.$set(row, 'payerTaxId', e.payerTaxId)
    },
    // 收款方类型改变
    collectionTypeFn (e, row) {
      if (e == 2) {
        this.$set(row, 'payer', row.driverName)
        this.$set(row, 'payerTaxId', row.idNumber)
        this.$set(row, 'payerCode', '')
      } else {
        this.$set(row, 'payer', '')
        this.$set(row, 'payerTaxId', '')
        this.$set(row, 'payerCode', '')
      }
    },
    // 收款方改变
    payerChange (e, row) {
      let json = this.CYSList.filter(item => item.customerName == row.payer)
      row.payerTaxId = json[0].customerTaxId
      row.payerCode = json[0].tenantCode
    },
    carBlurFn (index) {
      let data = this.goodform.billCarriers[index]
      if (!data.vehicleId) {
        this.$set(data, 'plateNumber', '')
      }
    },
    sijiBlurFn (index) {
      let data = this.goodform.billCarriers[index]
      if (!data.driverId) {
        this.$set(data, 'driverName', '')
      }
    },
    // 网货选司机
    sijiFn (index) {
      this.currentIndex = index
      this.WHxuansijiFlag = true
    },
    selectCar (row) {
      let data = this.goodform.billCarriers[this.currentIndex]
      this.$set(data, 'vehicleId', '')
      this.$set(data, 'plateNumber', row.vhcNo)
      this.$set(data, 'licensePlateColor', row.noColourCode)
      this.$set(data, 'licensePlateColorName', row.noColourName)
      this.$set(data, 'vehicleType', '')
      this.$set(data, 'vehicleTypeName', row.vhcTypeName)
      this.$set(data, 'energyType', '')
      this.$set(data, 'energyTypeName', row.energyName)
      this.$set(data, 'vehicleOwnership', 1)
      this.$set(data, 'vehicleOwnershipName', '外协')
      this.$set(data, 'vehicleLength', row.vhcLength)
      this.$set(data, 'driverId', '')
      this.$set(data, 'driverName', row.name)
      this.$set(data, 'driverPhone', row.mobile)
      this.$set(data, 'idNumber', row.identityNo)
      this.$set(data, 'driverOwnership', 1)
      this.$set(data, 'driverOwnershipName', '外协')
      if (data.collectionType == 2) {
        this.$set(data, 'payer', row.driverName)
        this.$set(data, 'payerTaxId', row.identityNo)
      }
    },
    // 推送网货改变
    TSWHchange (e, row) {
      let json = this.CYSList.filter(item => item.customerName == row.generalCarrier)
      this.whLuoji(json, row)
    },
    // 推送网货逻辑
    whLuoji (json, row) {
      if (row.onlineFreightFlag == 1) {
        pushWayToWHPTFlag().then(res => {
          if (res) {
            // 如果推送网货则清空司机信息
            this.$set(row, 'vehicleId', '')
            this.$set(row, 'plateNumber', '')
            this.$set(row, 'licensePlateColor', '')
            this.$set(row, 'licensePlateColorName', '')
            this.$set(row, 'vehicleType', '')
            this.$set(row, 'vehicleTypeName', '')
            this.$set(row, 'energyType', '')
            this.$set(row, 'energyTypeName', '')
            this.$set(row, 'vehicleOwnership', '')
            this.$set(row, 'vehicleOwnershipName', '')
            this.$set(row, 'vehicleLength', '')
            this.$set(row, 'driverId', '')
            this.$set(row, 'driverName', '')
            this.$set(row, 'driverPhone', '')
            this.$set(row, 'idNumber', '')
            this.$set(row, 'driverOwnership', '')
            this.$set(row, 'driverOwnershipName', '')

            this.$set(row, 'WHJKflag', true)
            getCustomerTaxRate({ generalCarrier: row.generalCarrier }).then(res => {
              this.$set(row, 'serviceRate', res * 100)
            }).catch(error => {
              this.$set(row, 'serviceRate', null)
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                }
              })
            })
          } else {
            this.$set(row, 'WHJKflag', false)
            // this.$set(row, 'serviceRate', json[0].serviceRate)
            row.gongzishuilv = json[0].payrollTaxPoint
            row.fuwufeilv = json[0].serviceRate
            if (row.isWuxian == null && row.driverId) { // 如果是回显过来没有值。所以走一遍接口
              findDriverInfoById({ id: row.driverId }).then(res => {
                row.isWuxian = res.fiveInsurances == '1'
                this.$set(row, 'serviceRate', row.isWuxian ? row.gongzishuilv : row.fuwufeilv)
              })
            } else {
              this.$set(row, 'serviceRate', row.isWuxian ? row.gongzishuilv : row.fuwufeilv)
            }
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      } else {
        this.$set(row, 'WHJKflag', false)
        // this.$set(row, 'serviceRate', json[0].serviceRate)
        row.gongzishuilv = json[0].payrollTaxPoint
        row.fuwufeilv = json[0].serviceRate
        if (row.isWuxian == null && row.driverId) { // 如果是回显过来没有值。所以走一遍接口
          findDriverInfoById({ id: row.driverId }).then(res => {
            row.isWuxian = res.fiveInsurances == '1'
            this.$set(row, 'serviceRate', row.isWuxian ? row.gongzishuilv : row.fuwufeilv)
          })
        } else {
          this.$set(row, 'serviceRate', row.isWuxian ? row.gongzishuilv : row.fuwufeilv)
        }
      }
    },
    // 承运商改变
    generalCarrierChange (e, row) {
      if (e) {
        let json = this.CYSList.filter(item => item.customerName == e)
        row.generalTaxId = json[0].customerTaxId
        row.generalCode = json[0].tenantCode
        row.generalPeriodDays = json[0].periodDays
        row.generalInvoiceDays = json[0].invoiceDays
        row.generalPeriodDaysType = json[0].periodDaysType
        this.$set(row, 'payer', row.generalCarrier)
        this.$set(row, 'payerTaxId', json[0].customerTaxId)
        this.$set(row, 'payerCode', json[0].tenantCode)
        this.$set(row, 'collectionType', 1)
        this.$set(row, 'onlineFlag', json[0].onlineFlag)
        this.$set(row, 'onlineFreightFlag', json[0].onlineFreightFlag)
        this.$set(row, 'reverseCountFlag', json[0].reverseCountFlag)
        this.$set(row, 'expenditurePattern', json[0].settlementType)
        this.$set(row, 'expenditurePatternName', json[0].settlementTypeName)
        this.$set(row, 'freightTaxRate', json[0].taxRate)
        this.whLuoji(json, row)
      } else {
        this.$set(row, 'onlineFreightFlag', null)
        this.$set(row, 'reverseCountFlag', null)
        this.$set(row, 'serviceRate', 0)
        row.generalTaxId = null
        row.generalCode = null
        row.generalPeriodDays = null
        this.$set(row, 'payer', null)
        this.$set(row, 'payerTaxId', null)
        this.$set(row, 'payerCode', null)
        this.$set(this.goodform, 'WHJKflag', false)
      }
    },
    addVL (index) {
      this.currentIndex = index
      this.addVehicleFlag = true
    },
    addsiji (index) {
      this.currentIndex = index
      this.addDriverFlag = true
    },
    dbSelected1 (row, index) {
      let data = this.goodform.billCarriers[index]
      this.$set(data, 'vehicleId', row.id)
      this.$set(data, 'licensePlateColorName', row.noColourName)
      this.$set(data, 'plateNumber', row.vhcNo)
      this.$set(data, 'licensePlateColor', row.noColourCode)
      this.$set(data, 'vehicleType', row.vhcTypeId)
      this.$set(data, 'vehicleTypeName', row.vhcTypeName)
      this.$set(data, 'energyType', row.energyId)
      this.$set(data, 'energyTypeName', row.energyName)
      this.$set(data, 'vehicleOwnership', row.vhcClassify == 2 ? 0 : row.vhcClassify)
      this.$set(data, 'vehicleOwnershipName', [ '外协', '自有' ][row.vhcClassify - 1])
      this.$set(data, 'vehicleLength', row.vhcLength)

      this.getziyouchePriceFn(data)

      getWayForPlateNumber({
        pageNo: 1,
        pageSize: 1,
        plateNumber: row.vhcNo
      }).then(res => {
        if (res.list.length > 0) {
          if (res.list[0].driverId && res.list[0].vehicleId) {
            let json = res.map.driverInfo
            this.$set(data, 'driverId', res.list[0].driverId)
            this.$set(data, 'driverName', json.name)
            this.$set(data, 'driverPhone', json.mobile)
            this.$set(data, 'idNumber', json.identityNo)
            this.$set(data, 'driverOwnership', res.map.driverClassify == 2 ? 0 : res.map.driverClassify)
            this.$set(data, 'driverOwnershipName', [ '外协', '自有' ][res.map.driverClassify - 1])

            if (data.collectionType == 2) {
              this.$set(data, 'payer', json.name)
              this.$set(data, 'payerTaxId', json.identityNo)
            }
            // 根据司机获取承运商逻辑
            if (!data.generalCarrier) {
              findDriverInfoById({ id: res.list[0].driverId }).then(res => {
                data.isWuxian = res.fiveInsurances == '1'
                if (res.ext1) {
                  this.$set(data, 'generalCarrier', res.ext1)
                  this.generalCarrierChange(res.ext1, data)
                }
                // 获取司机的小队公司信息
                this.$set(data, 'teamOrgId', res.teamOrgId)
                this.$set(data, 'teamOrgCode', res.teamOrgCode)
                this.$set(data, 'teamOrgName', res.teamOrgName)
                this.$set(data, 'companyOrgId', res.companyOrgId)
                this.$set(data, 'companyOrgCode', res.companyOrgCode)
                this.$set(data, 'companyOrgName', res.companyOrgName)
              })
            } else { // 司机工资五险逻辑
              if ((data.gongzishuilv == null || data.fuwufeilv == null) && data.generalCarrier) { // 没有服务费率先获取一下
                let json = this.CYSList.filter(item => item.customerName == data.generalCarrier)
                data.gongzishuilv = json[0].payrollTaxPoint
                data.fuwufeilv = json[0].serviceRate
              }
              findDriverInfoById({ id: res.list[0].driverId }).then(res => {
                data.isWuxian = res.fiveInsurances == '1'
                this.$set(data, 'serviceRate', data.isWuxian ? data.gongzishuilv : data.fuwufeilv)
                // 获取司机的小队公司信息
                this.$set(data, 'teamOrgId', res.teamOrgId)
                this.$set(data, 'teamOrgCode', res.teamOrgCode)
                this.$set(data, 'teamOrgName', res.teamOrgName)
                this.$set(data, 'companyOrgId', res.companyOrgId)
                this.$set(data, 'companyOrgCode', res.companyOrgCode)
                this.$set(data, 'companyOrgName', res.companyOrgName)
              })
            }
          }
        } else {
          this.$set(data, 'driverId', '')
          this.$set(data, 'driverName', '')
          this.$set(data, 'driverPhone', '')
          this.$set(data, 'idNumber', '')
          this.$set(data, 'driverOwnership', '')
          this.$set(data, 'driverOwnershipName', '')

          this.$set(data, 'teamOrgId', '')
          this.$set(data, 'teamOrgCode', '')
          this.$set(data, 'teamOrgName', '')
          this.$set(data, 'companyOrgId', '')
          this.$set(data, 'companyOrgCode', '')
          this.$set(data, 'companyOrgName', '')
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    dbSelected2 (row, index) {
      console.log(row, index)
      let data = this.goodform.billCarriers[index]
      this.$set(data, 'driverId', row.id)
      this.$set(data, 'driverName', row.name)
      this.$set(data, 'driverPhone', row.mobile)
      this.$set(data, 'idNumber', row.identityNo)
      this.$set(data, 'driverOwnership', row.driverClassify == 2 ? 0 : row.driverClassify)
      this.$set(data, 'driverOwnershipName', [ '外协', '自有' ][row.driverClassify - 1])
      if (data.collectionType == 2) {
        this.$set(data, 'payer', row.driverName)
        this.$set(data, 'payerTaxId', row.identityNo)
      }
      // 获取司机的小队公司信息
      this.$set(data, 'teamOrgId', row.teamOrgId)
      this.$set(data, 'teamOrgCode', row.teamOrgCode)
      this.$set(data, 'teamOrgName', row.teamOrgName)
      this.$set(data, 'companyOrgId', row.companyOrgId)
      this.$set(data, 'companyOrgCode', row.companyOrgCode)
      this.$set(data, 'companyOrgName', row.companyOrgName)
      // 根据司机获取承运商逻辑
      if (!data.generalCarrier) {
        data.isWuxian = row.fiveInsurances == 1
        if (row.ext1) {
          this.$set(data, 'generalCarrier', row.ext1)
          this.generalCarrierChange(row.ext1, data)
        }
      } else { // 司机工资五险逻辑
        if ((data.gongzishuilv == null || data.fuwufeilv == null) && data.generalCarrier) { // 没有服务费率先获取一下
          let json = this.CYSList.filter(item => item.customerName == data.generalCarrier)
          data.gongzishuilv = json[0].payrollTaxPoint
          data.fuwufeilv = json[0].serviceRate
        }
        data.isWuxian = row.fiveInsurances == '1'
        this.$set(data, 'serviceRate', data.isWuxian ? data.gongzishuilv : data.fuwufeilv)
      }
    },
    searchFn1 (str, cb, row) {
      this.$set(row, 'vehicleId', '')
      this.$set(row, 'licensePlateColor', '')
      this.$set(row, 'licensePlateColorName', '')
      this.$set(row, 'vehicleType', '')
      this.$set(row, 'vehicleTypeName', '')
      this.$set(row, 'energyType', '')
      this.$set(row, 'energyTypeName', '')
      this.$set(row, 'vehicleOwnership', '')
      this.$set(row, 'vehicleOwnershipName', '')
      this.$set(row, 'vehicleLength', '')
      this.searchFrom1.vhcNoLike = str
      // if (row.generalCarrier) {
      //   this.searchFrom1.vhcClassify = 1
      // } else {
      //   this.searchFrom1.vhcClassify = ''
      // }
      cVIlist(this.searchFrom1).then(res => {
        cb(res.list)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    searchFn2 (str, cb, row) {
      this.$set(row, 'driverId', '')
      this.$set(row, 'driverPhone', '')
      this.$set(row, 'idNumber', '')
      this.$set(row, 'driverOwnership', '')
      this.$set(row, 'driverOwnershipName', '')
      this.searchFrom2.name = str
      // if (row.generalCarrier) {
      //   this.searchFrom2.driverClassify = 1
      // } else {
      //   this.searchFrom2.driverClassify = ''
      // }
      cDlist(this.searchFrom2).then(res => {
        cb(res.list)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    }
  },
  watch: {
    goodform: {
      handler (newName, oldName) {
        this.goodform.billCarriers.forEach(item => {
          if (this.goodform.orderWeight && item.freightUnitPrice) {
            this.$set(item, 'freightAmount', toFixed(accMul(this.goodform.orderWeight, item.freightUnitPrice), 2))
          }
          // 网货反算。服务费 = 运费/（1-服务费率）* 服务费率  合计 = 运费 /（1-服务费率）
          if (item.onlineFreightFlag == 1) {
            if (item.freightAmount && item.serviceRate) {
              let n = item.serviceRate / 100
              this.$set(item, 'serviceCharge', toFixed(item.freightAmount / (1 - n) * n, 2))
            } else {
              this.$set(item, 'serviceCharge', 0)
            }
          } else {
            if (item.freightAmount && item.serviceRate) {
              let n = item.serviceRate / 100
              this.$set(item, 'serviceCharge', toFixed(accMul(item.freightAmount, n), 2))
            } else {
              this.$set(item, 'serviceCharge', 0)
            }
          }
        })

        function accMul (arg1, arg2) {
          var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {
          }
          try {
            m += s2.split('.')[1].length
          } catch (e) {
          }

          return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
        }
      },
      deep: true
    }
  }

}
</script>

<style scoped lang='less'>
.tableTop{
  display: flex;
  align-items: center;
  &.has-locate{
    margin-bottom: 10px;
  }
  .locateBox{
    display: flex;
    align-items: center;
    margin-left: 12px;
    .locateInput{
      width: 200px;
      margin-right: 8px;
    }
  }
}
/* 定位命中的行高亮 */
/deep/ .el-table__body tbody > tr.locate-highlight > td{
  background-color: #ffe58f !important;
}
.width2 /deep/.el-input__inner{
  width: 100px;
}
/deep/.el-autocomplete-suggestion li{
  padding: 0 10px;
  overflow: auto;
  text-align: left;
}
/deep/.xiala{
  width: 240px!important;
}
/deep/.el-icon-circle-plus-outline{
  font-size: 20px;
  margin-left:6px ;
  color: #bfc0c3;
}
</style>
